import React from "react";
import classes from "./InfluencerCards.module.css";
import { InstagramLogoIcon } from "@radix-ui/react-icons";

const InfluencerCards = (props) => {
  const influencerData = props.influencerData;
  const instaOpener = (influencer) => {
    window.open(
      `https://www.instagram.com/${influencer?.instaId}`
    );
  }

  const cardsWeb = (
    <div className="hidden lg:flex">
      <div className={classes["influencer-container"]}>
        {influencerData.map((influencer) => {
          return (
            <>
              <div className={classes["influencer-card"]}>
                <div className={classes["influencer-card-inner-container"]}>
                  <p className={classes["influencer-inner-name"]}>
                    {influencer.name}
                  </p>
                  <div className={classes["influencer-img-container"]}>
                    <img
                      className={`${classes["influencer-insta"]} cursor-pointer`}
                      src="https://static.wixstatic.com/media/dd0cc5_81a6acca31034dcd871cd6c658e73590~mv2.webp"
                      alt=""
                      onClick={() => {
                        window.open(
                          `https://www.instagram.com/${influencer.instaId}`
                        );
                      }}
                    />

                    <div className={classes["influencer-info"]}>
                      <p className={classes["influencer-info-text"]}>
                        {influencer.instaId}
                      </p>
                      <p className={classes["influencer-info-text"]}>
                        {influencer.followers}
                      </p>
                    </div>
                  </div>
                </div>

                <img
                  className={classes["influencer-bg-img"]}
                  src={influencer.img}
                  alt=""
                />
                <img
                  className={classes["influencer-img"]}
                  src={influencer.influencerImage}
                  alt=""
                />
              </div>
            </>
          );
        })}
      </div>
    </div>
  );

  const cardsMobile = (
    <div className="lg:hidden">
      <div className={classes["influencer-container"]}>
        {influencerData.map((influencer, influencerIndex) => {
          return (
            <div>
              <div
                className={classes["influencer-card"]}
                style={{
                  marginRight: `${
                    influencerIndex + 1 === influencerData.length && "0vw"
                  }`,
                }}
              >
                {/* <div className={classes["influencer-card-inner-container"]}>
                  <p className={classes["influencer-inner-name"]}>
                    {influencer.name}
                  </p>
                  <div className={classes["influencer-img-container"]}>
                    <img
                      className={classes["influencer-insta"]}
                      src="https://static.wixstatic.com/media/dd0cc5_81a6acca31034dcd871cd6c658e73590~mv2.webp"
                      alt=""
                    />

                    <div className={classes["influencer-info"]}>
                      <p className={classes["influencer-info-text"]}>
                        {influencer.instaId}
                      </p>
                      <p className={classes["influencer-info-text"]}>
                        {influencer.followers}
                      </p>
                    </div>
                  </div>
                </div> */}

                <div className="w-[100%] h-[100%] relative flex flex-row items-end justify-end">
                  <img
                    className="w-[100%] h-[100%] object-cover absolute z-[-1]"
                    src={influencer.img}
                    alt=""
                  />
                  <div className="w-[auto] h-[auto] mt-[auto] flex items-end">
                    <img
                      className="w-[auto] h-[40vw] object-cover"
                      src={influencer.influencerImage}
                      alt=""
                    />
                  </div>
                </div>

                {/* <img
                  className={classes["influencer-bg-img"]}
                  src={influencer.img}
                  alt=""
                />
                <img
                  className={classes["influencer-img"]}
                  src={influencer.influencerImage}
                  alt=""
                /> */}
              </div>
              <div className="w-[90%] h-[auto]">
                <p className="font-bold text-lg">{influencer?.name}</p>
                <div className="flex flex-row">
                <InstagramLogoIcon onClick={() => {instaOpener(influencer)}} className="text-red-600 w-[40px] h-[40px] mr-[2vw]" />
                  <div className="text-sm">
                    <p className="text-blue-700" onClick={() => {instaOpener(influencer)}}>{influencer?.instaId}</p>
                    <p>{influencer?.followers}</p>
                  </div>
                  
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      {cardsWeb}
      {cardsMobile}
    </>
  );
};

export default InfluencerCards;
